import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLoading } from "../../../redux/ducks/Loading";
import { t } from "i18next";
import { VictoryBar, VictoryChart, VictoryAxis, VictoryLabel } from "victory";
import { Row, Col } from "antd";
import { showError } from "../../../utils/utilities";
import { get } from "lodash";
import TimesheetApprovalApi from "../../../services/api/TimesheetApprovalApi";
import "../TimesheetTable.css";

// Componente per mostrare il grafico delle ore di un singolo CDC (usato nella dashboard)
const CostCentreChartCard = ({ costCentreData, cardsPerRow }) => {
  const barColors = ["#ffc000", "#ffff00", "#92d050"];
  const labels = [
    t("timesheet.approval.dashboard.approvedHours"),
    t("timesheet.approval.dashboard.insertedHours"),
    t("timesheet.approval.dashboard.adpHours"),
  ];
  const fontSize = "14px";

  return (
    <Col span={cardsPerRow && cardsPerRow > 1 ? 24 / cardsPerRow : 12}>
      <Row key={`${costCentreData.id}_row`}>
        <Col span={4} className="cdcDashboardTitleCol">
          <h2 className="cdcDashboardTitle">{t("timesheet.approval.dashboard.cdc") + " " + costCentreData.id}</h2>
        </Col>
        <Col span={20}>
          <VictoryChart
            key={`${costCentreData.id}_chart`}
            horizontal
            padding={{ top: 20, bottom: 20, left: 170, right: 20 }}
            domainPadding={{ x: 0, y: 15 }}
            height={80}
          >
            {/* Asse verticale con etichette */}
            <VictoryAxis
              tickValues={labels}
              tickFormat={labels}
              style={{
                axis: { stroke: "none" },
                ticks: { stroke: "none" },
                tickLabels: {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: fontSize,
                  padding: 15,
                  textAnchor: "end",
                  fill: "black",
                },
              }}
            />
            {/* Asse orizzontale non visibile */}
            <VictoryAxis
              dependentAxis={true}
              domain={[
                0,
                Math.max(costCentreData.adpHours, costCentreData.insertedHours, costCentreData.approvedHours) * 1.2,
              ]}
              style={{
                axis: { stroke: "none" },
                ticks: { stroke: "none" },
                tickLabels: { fill: "none" },
              }}
            />
            {/* Grafico a barre */}
            <VictoryBar
              data={[
                { x: labels[0], y: costCentreData.approvedHours, label: String(costCentreData.approvedHours) },
                { x: labels[1], y: costCentreData.insertedHours, label: String(costCentreData.insertedHours) },
                { x: labels[2], y: costCentreData.adpHours, label: String(costCentreData.adpHours) },
              ]}
              x="x"
              y="y"
              labels={({ datum }) => datum.label}
              barWidth={14}
              style={{
                data: {
                  fill: ({ index }) => barColors[index],
                },
                labels: {
                  fontFamily: "Roboto, sans-serif",
                  fontSize: fontSize,
                  fontWeight: "bold",
                  fill: "black",
                },
              }}
              labelComponent={<VictoryLabel dx={5} textAnchor="start" />}
            />
          </VictoryChart>
        </Col>
      </Row>
    </Col>
  );
};

const CostCentresDashboard = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    dashboardData: [],
  });

  useEffect(() => {
    getDashboardData();
  }, []);

  const getDashboardData = async () => {
    dispatch(setLoading(true));
    const data = await TimesheetApprovalApi.getDashboardData();
    if (!data.error) {
      const dashboardData = [];
      let costCentreData = {};
      for (const costCentre in data.costCentreValues) {
        costCentreData = {
          id: costCentre,
          adpHours: data.costCentreValues[costCentre].adpHours,
          insertedHours: data.costCentreValues[costCentre].insertedHours,
          approvedHours: data.costCentreValues[costCentre].approvedHours,
        };
        dashboardData.push(costCentreData);
      }
      setState((prevState) => ({
        ...prevState,
        dashboardData: dashboardData,
      }));
    } else {
      showError(get(data.data, "error.messageCode", "ER000"));
    }
    dispatch(setLoading(false));
  };

  return (
    <>
      {state.dashboardData ? (
        <Row justify={state.dashboardData.length === 1 ? "center" : "start"}>
          {state.dashboardData.map((item) => (
            <CostCentreChartCard
              costCentreData={item}
              cardsPerRow={state.dashboardData.length <= 3 ? state.dashboardData.length : 3}
              key={`${item.id}_card`}
            />
          ))}
        </Row>
      ) : (
        <></>
      )}
    </>
  );
};

export default CostCentresDashboard;
